import { CHAT_ERROR_MESSAGES } from 'modules/chat/domain/constants';
import { ChatRequestError } from 'modules/chat/domain/interfaces';
import type { MessageDescriptor } from 'shared/i18n';

/** Текст сервера показывается как есть, иначе — перевод кода; `translate` — `t` из `useLingui()` или `i18n._`. */
export function getChatErrorText(error: ChatRequestError, translate: (descriptor: MessageDescriptor) => string): string {
  if (error.message) return error.message;
  return translate(CHAT_ERROR_MESSAGES[error.code ?? 'SEND_FAILED']);
}
